import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "container text-center mt-5" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "title color-gray" }, "Portfolio (freelancer)", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", { class: "color-gray" }, "Projects", -1)
const _hoisted_4 = { class: "row mt-5" }
const _hoisted_5 = { style: {"height":"80px"} }
const _hoisted_6 = ["src"]
const _hoisted_7 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.projects, (project, key) => {
        return (_openBlock(), _createElementBlock("article", {
          class: "col-lg-4 col-md-6 col-sm-12 mt-5",
          key: key
        }, [
          _createElementVNode("h3", _hoisted_5, _toDisplayString(project.title), 1),
          _createElementVNode("figure", null, [
            _createElementVNode("img", {
              src: project.image
            }, null, 8, _hoisted_6)
          ]),
          _createElementVNode("p", null, [
            _createElementVNode("a", {
              href: project.href,
              target: "_blank"
            }, _toDisplayString(project.domain), 9, _hoisted_7)
          ])
        ]))
      }), 128))
    ])
  ]))
}